{
  "name": "Compare the common 12-tone systems",
  "description": "Four common tunings of the chromatic 12-tone scale are combined in one 48-tone layout (pitches which are the same in different tunings are repeated): 12edo (tempered HEJI accidentals), Pythagorean (uninflected accidentals), 1/4-Syntonic Comma Meantone (notated with small letters), and Ptolemaic 5-Limit JI (with additional arrows indicating the Comma alterations).",
  "scale": [
    "0.0",
    "0.0",
    "0.0",
    "76.04899926",
    "256/243",
    "100.0",
    "16/15",
    "10/9",
    "193.1568569",
    "200.0",
    "9/8",
    "32/27",
    "300.0",
    "310.2647146",
    "6/5",
    "5/4",
    "386.3137139",
    "400.0",
    "81/64",
    "4/3",
    "4/3",
    "500.0",
    "503.4215715",
    "579.4705708",
    "45/32",
    "600.0",
    "729/512",
    "696.5784285",
    "700.0",
    "3/2",
    "3/2",
    "772.6274277",
    "128/81",
    "800.0",
    "8/5",
    "5/3",
    "889.7352854",
    "900.0",
    "27/16",
    "16/9",
    "1000.0",
    "1006.843143",
    "9/5",
    "1082.892142",
    "15/8",
    "1100.0",
    "243/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-tone-combined",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "C",
    "C",
    "C",
    "♯c",
    "D",
    "C D",
    "D",
    "D",
    "d",
    "D",
    "D",
    "E",
    "D E",
    "♭e",
    "E",
    "e",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "f",
    "♯f",
    "F",
    "F G",
    "F",
    "g",
    "G",
    "G",
    "G",
    "♯g",
    "A",
    "G A",
    "A",
    "A",
    "a",
    "A",
    "A",
    "B",
    "A B",
    "♭b",
    "B",
    "b",
    "B",
    "B",
    "B"
  ],
  "note_colors": [
    "#f9f7eb",
    "#ffffff",
    "#ededf7",
    "#ffffff",
    "#eee9d3",
    "#d0d0d7",
    "#c3c3d5",
    "#dee2da",
    "#fffae5",
    "#f9f7eb",
    "#ededf7",
    "#ffffff",
    "#d0d0d7",
    "#c3c3d5",
    "#e2dfcf",
    "#dee2da",
    "#f9f7eb",
    "#fffae5",
    "#ededf7",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ededf7",
    "#f9f7eb",
    "#eee9d3",
    "#fffae5",
    "#c3c3d5",
    "#d0d0d7",
    "#f9f7eb",
    "#ededf7",
    "#ffffff",
    "#ffffff",
    "#eee9d3",
    "#d0d0d7",
    "#c3c3d5",
    "#dee2da",
    "#fffae5",
    "#f9f7eb",
    "#ededf7",
    "#ffffff",
    "#d0d0d7",
    "#c3c3d5",
    "#e2dfcf",
    "#dee2da",
    "#f9f7eb",
    "#fffae5",
    "#ededf7",
    "#ffffff"
  ],
  "equivSteps": 48,
  "fundamental": 440,
  "reference_degree": 39,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": -1,
  "hexSize": 42,
  "rotation": 40.9
}
